
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-gray-900 to-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-6">
              <i className="ri-shield-user-line text-3xl text-white"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Gizlilik Politikası
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Kişisel verilerinizin korunması bizim için önceliklidir. Bu politika, 
              verilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            
            {/* Veri Toplama */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                    <i className="ri-database-2-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">Topladığımız Bilgiler</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        Web sitemizi ziyaret ettiğinizde ve hizmetlerimizi kullandığınızda aşağıdaki bilgileri toplayabiliriz:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li><strong className="text-white">Kişisel Bilgiler:</strong> Ad, soyad, e-posta adresi, telefon numarası</li>
                        <li><strong className="text-white">İletişim Bilgileri:</strong> Adres, posta kodu, şehir bilgileri</li>
                        <li><strong className="text-white">Ödeme Bilgileri:</strong> Kredi kartı bilgileri (güvenli ödeme sistemleri aracılığıyla)</li>
                        <li><strong className="text-white">Teknik Bilgiler:</strong> IP adresi, tarayıcı türü, işletim sistemi</li>
                        <li><strong className="text-white">Kullanım Bilgileri:</strong> Site içi gezinme davranışları, tercihler</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Veri Kullanımı */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-600 rounded-lg flex-shrink-0">
                    <i className="ri-settings-3-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">Bilgileri Nasıl Kullanırız</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        Topladığımız bilgileri aşağıdaki amaçlarla kullanırız:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li>Sipariş işlemlerini gerçekleştirmek ve teslimat yapmak</li>
                        <li>Müşteri hizmetleri desteği sağlamak</li>
                        <li>Ödeme işlemlerini güvenli şekilde gerçekleştirmek</li>
                        <li>Web site deneyimini kişiselleştirmek</li>
                        <li>Yasal yükümlülüklerimizi yerine getirmek</li>
                        <li>Pazarlama ve promosyon faaliyetleri (izniniz dahilinde)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* KVKK Uyumluluğu */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-600 rounded-lg flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">KVKK Uyumluluğu</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li>Kişisel verileriniz yasal dayanaklar çerçevesinde işlenir</li>
                        <li>Verileriniz yalnızca belirtilen amaçlarla kullanılır</li>
                        <li>Veri minimizasyonu ilkesi uygulanır</li>
                        <li>Verileriniz güvenli şekilde saklanır ve korunur</li>
                        <li>Haklarınızı kullanmak için başvuru yapabilirsiniz</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Veri Güvenliği */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-600 rounded-lg flex-shrink-0">
                    <i className="ri-lock-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">Veri Güvenliği</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        Kişisel verilerinizin güvenliği için aşağıdaki önlemleri alırız:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li><strong className="text-white">SSL Şifreleme:</strong> Tüm veri transferleri 256-bit SSL ile şifrelenir</li>
                        <li><strong className="text-white">Güvenli Sunucular:</strong> Veriler güvenli veri merkezlerinde saklanır</li>
                        <li><strong className="text-white">Erişim Kontrolü:</strong> Yetkili personel dışında erişim engellenir</li>
                        <li><strong className="text-white">Düzenli Yedekleme:</strong> Veri kaybına karşı düzenli yedekleme yapılır</li>
                        <li><strong className="text-white">Güvenlik Testleri:</strong> Düzenli güvenlik denetimleri gerçekleştirilir</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Çerezler */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-600 rounded-lg flex-shrink-0">
                    <i className="ri-cookie-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">Çerez Politikası</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        Web sitemizde kullanılan çerez türleri:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li><strong className="text-white">Zorunlu Çerezler:</strong> Site işlevselliği için gerekli</li>
                        <li><strong className="text-white">Performans Çerezleri:</strong> Site performansını ölçmek için</li>
                        <li><strong className="text-white">İşlevsellik Çerezleri:</strong> Kullanıcı deneyimini geliştirmek için</li>
                        <li><strong className="text-white">Pazarlama Çerezleri:</strong> Kişiselleştirilmiş reklamlar için (izninizle)</li>
                      </ul>
                      <p className="mt-4">
                        Çerez ayarlarınızı tarayıcınızdan yönetebilir veya devre dışı bırakabilirsiniz.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Haklarınız */}
            <div className="mb-12">
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-indigo-600 rounded-lg flex-shrink-0">
                    <i className="ri-user-settings-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-4">Kişisel Veri Haklarınız</h2>
                    <div className="prose prose-lg text-gray-300">
                      <p className="mb-4">
                        KVKK kapsamında aşağıdaki haklara sahipsiniz:
                      </p>
                      <ul className="list-disc pl-6 space-y-2">
                        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                        <li>İşlenen kişisel verileriniz hakkında bilgi talep etme</li>
                        <li>İşleme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                        <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                        <li>Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
                        <li>Kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* İletişim Bilgileri */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4">İletişim Bilgileri</h2>
              <p className="text-gray-300 mb-4">
                Bu gizlilik politikası hakkında sorularınız varsa, bizimle iletişime geçebilirsiniz:
              </p>
              <div className="bg-gray-800 p-6 rounded-lg">
                <p className="text-white mb-2"><strong>Nox Sanat</strong></p>
                <p className="text-gray-300 mb-2">
                  Gayrette Mahallesi, Çimen Sokak, Girne Apartmanı<br />
                  Beşiktaş / İstanbul
                </p>
                <p className="text-gray-300 mb-2">Telefon: +90 212 555 0123</p>
                <p className="text-gray-300">E-posta: info@noxsanat.com</p>
              </div>
            </div>

            {/* Son Güncelleme */}
            <div className="mt-12 text-center text-gray-400">
              <p className="text-sm">
                Bu gizlilik politikası son olarak 15 Ocak 2024 tarihinde güncellenmiştir.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
